import { Injectable, NgZone } from '@angular/core'
import { WindowService } from './window.service'

const DATA_LAYER_NAME = 'dataLayer'

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  private _window: Window

  constructor(
    _windowService: WindowService,
    private _ngZone: NgZone
  ) {
    this._window = _windowService.window
  }

  public install(identifier: string) {
    if (typeof identifier !== 'string' || identifier.trim().length === 0) {
      throw new Error('Google Tag Manager ID is undefined')
    }
    this._window[DATA_LAYER_NAME] = []

    this._ngZone.runOutsideAngular(() => {
      (function(w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({
          'gtm.start': new Date().getTime(),
          'event': 'gtm.js'
        })
        const f = d.getElementsByTagName(s)[0]
        const j = d.createElement(s) as HTMLScriptElement
        const dl = l !== 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(this._window, this._window.document, 'script', DATA_LAYER_NAME, identifier)
    })
  }
}
